import React, { useContext } from "react";
import { FormControlLabel, Checkbox, Box, Typography } from "@mui/material";
import { getColors } from "../../../themes/theme";
import { ThemeContext } from "../../../context/ThemeContext";

export const CarePlanEstimationItem = ({
  id,
  name,
  packages,
  discount,
  onClick,
  onDelete,
  onSave,
  onCheck,
  isChecked, // Prop passed from the parent
}) => {
  const { darkMode } = useContext(ThemeContext);

  const handleCheckboxChange = (event) => {
    event.stopPropagation(); // Prevent the Box's onClick from being triggered

    onCheck(id, event.target.checked); // Notify parent about the change
  };

  return (
    <>
      <Box
        sx={{
          width: "100%",
          px: { xs: 2, sm: "20px", md: 2, lg: "20px" },
          py: "12px",
          borderRadius: "5px",
          borderWidth: 1,
          borderStyle: "solid",
          borderColor: darkMode
            ? getColors.thumbnailBorderDark
            : getColors.thumbnailBorderLight,
          background: darkMode
            ? getColors.thumbnnailBgDark
            : getColors.thumbnnailBgLight,
          cursor: "pointer",
          "&:hover": {
            borderColor: darkMode
              ? getColors.thumbnailTextDark
              : getColors.thumbnailTextLight,
          },
        }}
        onClick={() => onCheck(id, !isChecked)} // Toggle checkbox when the Box is clicked
      >
        <Box
          display={"flex"}
          justifyContent="space-between"
          sx={{ alignItems: "center" }}
        >
          <Typography
            sx={{
              fontSize: "22px",
              fontWeight: 500,
              color: darkMode
                ? getColors.drawerTextDark
                : getColors.thumbnailTextLight,
            }}
          >
            {name}
          </Typography>
          <FormControlLabel
            sx={{ margin: 0 }}
            control={
              <Checkbox
                checked={isChecked} // Bind the checkbox state
                onChange={handleCheckboxChange} // Allow manual toggling
                sx={{
                  "&.Mui-checked": {
                    color: "inherit",
                  },
                }}
              />
            }
          />
        </Box>
      </Box>
    </>
  );
};
